// extracted by mini-css-extract-plugin
export default {"wrapper":"RQ","dropdownButton":"SQ","carat":"TQ","caratPointingDown":"UQ","selectBox":"VQ","dropdown":"WQ","header":"XQ","instructions":"YQ","counter":"ZQ","itemWrapper":"aR","flavorImg":"bR","left":"cR","quantityControl":"eR","quantity":"fR","qtyButton":"gR","minus":"hR","plus":"iR"};
    if(module.hot) {
      // 1738836197367
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  